// @flow
// Package level constants.
export const PACKAGE_REQUEST = 'PACKAGE_REQUEST';
export const PACKAGE_RECEIVE = 'PACKAGE_RECEIVE';
export const PACKAGE_INITIAL = 'PACKAGE_INITIAL';
export const PACKAGE_UPDATE = 'PACKAGE_UPDATE';

// Section level constants.
export const SECTION_NEXT = 'SECTION_NEXT';

// Page level constants.
export const PAGE_NEXT = 'PAGE_NEXT';

// Step level constants.
export const STEP_NEXT = 'STEP_NEXT';
export const STEP_PREV = 'STEP_PREV';

// Element.
export const ELEMENT_TOGGLE = 'ELEMENT_TOGGLE';
